import { traceStore } from './traceStore';

export const traceRecorder = {
    recordAIIntent(intent: string, query: string) {
        traceStore.add({
            type: "AI_INTENT",
            label: `User intended: ${intent}`,
            details: { query, intent },
            source: "AI"
        });
    },

    recordDecision(label: string, anchor: { lat: number, lon: number }, data?: any) {
        traceStore.add({
            type: "SPATIAL_DECISION",
            label,
            details: { anchor, ...data },
            source: "AI"
        });
    },

    recordCameraDispatch(action: string, payload: any) {
        traceStore.add({
            type: "CAMERA_DISPATCH",
            label: `Dispatch: ${action}`,
            details: payload,
            source: payload.source === "USER" ? "USER" : "AI"
        });
    },

    recordMapUpdate(action: string, result: string, payload?: any) {
        traceStore.add({
            type: "MAP_ACTION",
            label: `${action} -> ${result}`,
            details: payload,
            source: "SYSTEM"
        });
    },

    recordSystemRecovery(error: string, fix: string) {
        traceStore.add({
            type: "SYSTEM_RECOVERY",
            label: `Recovering from ${error}`,
            details: { fix },
            source: "SYSTEM"
        });
    },

    recordNavigationTelemetry(metrics: { 
        duration?: number, 
        coalesced?: boolean, 
        userOverride?: boolean, 
        animationAbort?: boolean, 
        markerCount?: number,
        startCenter?: [number, number],
        targetCenter?: [number, number]
    }) {
        traceStore.add({
            type: "NAV_TELEMETRY",
            label: "Navigation Telemetry Log",
            details: metrics,
            source: "SYSTEM"
        });
    },
    
    recordModeSwitch(from: string, to: string) {
        traceStore.add({
            type: "MODE_SWITCH",
            label: `Mode changed: ${from} -> ${to}`,
            details: { from, to },
            source: "SYSTEM"
        });
    },

    recordCameraLoaded(location: any) {
        traceStore.add({
            type: "CAMERA_LOADED",
            label: "Camera reached destination",
            details: { location },
            source: "SYSTEM"
        });
    },

    recordMarkersRendered(count: number, source: string) {
        traceStore.add({
            type: "MARKERS_RENDERED",
            label: `Rendered ${count} nodes`,
            details: { count, source },
            source: "SYSTEM"
        });
    }
};

if (typeof window !== 'undefined') {
    (window as any).WingmanTraceRecorder = traceRecorder;
}
